export default [
  {
    con: 'difference.con.desc',
    electricity: 'difference.con.electricity',
    freon: true,
    humidify: false,
    portable: false,
    noisiness: true,
    design: false,
  },
  {
    fan: 'difference.fan.desc',
    electricity: 'difference.fan.electricity',
    freon: false,
    humidify: false,
    portable: true,
    noisiness: true,
    design: false,
  },
];
